import { forwardRef, type InputHTMLAttributes } from 'react';

import { cn } from '@/lib/cn';

/**
 * Input field with the Outflanq token system. All inputs share the same
 * h-10 baseline so they line up with Buttons in toolbars and forms.
 */
export type InputProps = InputHTMLAttributes<HTMLInputElement>;

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, type = 'text', ...props }, ref) => {
    return (
      <input
        ref={ref}
        type={type}
        className={cn(
          'flex h-10 w-full rounded-sm bg-bg-tertiary px-md py-2',
          'text-sm text-text-primary placeholder:text-text-muted',
          'border border-border',
          'transition-colors duration-fast',
          'focus-visible:outline-hidden focus-visible:border-accent focus-visible:border-2',
          'disabled:cursor-not-allowed disabled:opacity-50',
          'file:border-0 file:bg-transparent file:text-sm file:font-medium',
          // Color inputs ignore most box styling — keep them compact and clean
          type === 'color' && 'h-10 w-16 p-1 cursor-pointer',
          className,
        )}
        {...props}
      />
    );
  },
);
Input.displayName = 'Input';
